<template>
  <div>
    <div class="row mb-3">
      <Period-Selector/>
      <Company-Selector/>
    </div>
    <br>
    <Leads-Card/>
  </div>
</template>

<script>
export default {
  
}
</script>

<style>

</style>